import styled from 'styled-components'
// components
import { Paper as PaperOrigin } from 'components/UI'

export const FieldsContainer = styled.div`
  max-width: 340px;
  gap: 16px;
  display: flex;
  flex-direction: column;
`

export const Paper = styled(PaperOrigin)`
  && {
    width: 100%;
    padding: 20px;
    max-width: 1200px;
  }
`
